export default __webpack_public_path__ + "static/006-b6f0b091b2e6b3673d03f55baef148a9.png";